import { Link } from "react-router-dom";

export const Footer = () => (
    <footer className="border-t border-white/[0.08] py-10" aria-label="Fußzeile">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
            <div>
                <Link to="/" data-testid="footer-logo" className="flex items-center gap-2.5">
                    <span className="status-dot h-2.5 w-2.5 rounded-full bg-emerald-500" aria-hidden="true" />
                    <span className="font-heading font-semibold text-lg tracking-tight">Kirenzo</span>
                </Link>
                <p className="mt-2 text-sm text-[#6B7280]">
                    Individuelle KI-Automatisierung für KMU im deutschsprachigen Raum.
                </p>
            </div>
            <div className="flex flex-col sm:items-end gap-2 text-sm">
                <a
                    href="mailto:info@kirenzo.de"
                    data-testid="footer-email-link"
                    className="text-emerald-400 hover:text-emerald-300 transition-colors duration-200"
                >
                    info@kirenzo.de
                </a>
                <div className="flex gap-5 text-[#6B7280]">
                    <Link to="/impressum" data-testid="footer-impressum-link" className="hover:text-white transition-colors duration-200">
                        Impressum
                    </Link>
                    <Link to="/datenschutz" data-testid="footer-datenschutz-link" className="hover:text-white transition-colors duration-200">
                        Datenschutz
                    </Link>
                </div>
                <p className="text-xs text-[#6B7280]">© {new Date().getFullYear()} Kirenzo. Alle Rechte vorbehalten.</p>
            </div>
        </div>
    </footer>
);
